import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatSnackBar } from '@angular/material';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { PatternAltitude } from '../models/pattern-altitude.model';
import { PatternAltService } from '../service/pattern-alt.service';


@Component({
  selector: 'app-edit-pattern-altitude',
  templateUrl: './edit-pattern-altitude.component.html',
  styleUrls: ['./edit-pattern-altitude.component.scss']
})
export class EditPatternAltitudeComponent implements OnInit {
  patternAlt: PatternAltitude;
  originalPatternAlt: PatternAltitude;
  isNew = false;
  isLoading = false;
  airportID: number;
  itemsToChange: Set<number>;
  formGroup: FormGroup;
  selectedAircraftClass: string;
  selectedAltitude: string;
  patternAltitudes: Array<PatternAltitude>;

  constructor(private _matDialogRef: MatDialogRef<EditPatternAltitudeComponent>,
              private _patternAltService: PatternAltService,
              public _snackBar: MatSnackBar,
              @Inject(MAT_DIALOG_DATA) data) {
    this.patternAlt = data.patternAlt || new PatternAltitude();
    this.isNew = data.isNew || false;
    this.airportID = data.airID;
    this.originalPatternAlt = Object.assign(new PatternAltitude(), data.patternAlt);
    this.itemsToChange = new Set<number> ();
    this.selectedAircraftClass = PatternAltitude.formatAircraftClass(this.patternAlt.aircraftClass);
    this.selectedAltitude = this.patternAlt.altitude ? this.patternAlt.altitude.toFixed(0) : '';
    this.patternAltitudes = data.patternAltitudes || [];
  }

  ngOnInit() {
    this._matDialogRef.backdropClick().subscribe(() => {
      this.close({cancelBtnClicked: true});
    });
    this.formGroup = new FormGroup({
      aircraftClass: new FormControl(this.selectedAircraftClass, [Validators.required]),
      altitude: new FormControl(this.selectedAltitude, [Validators.required, Validators.maxLength(6),
        Validators.pattern('\\d+')])
    });
  }

  /**
   * triggered by save button click event
   * @return {Promise<void>}
   */
  async save() {
    try {
      let res: any;
      this.patternAlt.aircraftClass = PatternAltitude.parseAircraftClass(this.formGroup.get('aircraftClass').value);
      this.patternAlt.altitude = this.formGroup.get('altitude').value;
      if (this.isNew) {
        if (this.patternAltitudes.filter(element => element.aircraftClass === this.patternAlt.aircraftClass).length > 0) {
          this._snackBar.open('There is already a pattern altitude for this aircraft class.  ' +
            'If it is incorrect, please go back end edit it.', 'Pattern Altitude', {
            duration: 8000
          });
          return;
        }
        res = await this._patternAltService.postPatternAlt(this.airportID, this.patternAlt);
        this.patternAlt = PatternAltitude.parse(res);
      } else {
        res = await this._patternAltService.putPatternAlt(this.airportID, this.patternAlt);
        Object.assign(this.patternAlt, PatternAltitude.parse(res));
        this.patternAlt = PatternAltitude.parse(res);
      }
      this.close({cancelBtnClicked: false, success: true, patternAlt: this.patternAlt});
    } catch (e) {
      this.close({cancelBtnClicked: false, success: false});
    }
  }

  /**
   * triggered by cancel button click event
   */
  cancel () {
    this.close({cancelBtnClicked: true});
  }

  /**
   * closes modal
   * @param data
   */
  close(data: any) {
    if (data && data.cancelBtnClicked) {
      Object.assign(this.patternAlt, this.originalPatternAlt);
    }
    data['isNew'] = this.isNew;
    this._matDialogRef.close(data);
  }
}
